import { complianceOptionLabelKey } from 'intl/helpers/inspection/complianceOptionLabelKey';
import { Translate } from 'intl/translate';
import { ComplianceAnswerOption } from './complianceAnswerOption';

export function resolveComplianceOptionLabel(
  option: ComplianceAnswerOption,
  label: string,
  translate: Translate
): string {
  const trimmed = label.trim();
  if (trimmed) {
    return trimmed;
  }

  return translate(complianceOptionLabelKey(option));
}

export function withDefaultComplianceOptionLabels<
  T extends { option: ComplianceAnswerOption; label: string },
>(optionLabels: readonly T[], translate: Translate): T[] {
  return optionLabels.map((optionLabel) => ({
    ...optionLabel,
    label: resolveComplianceOptionLabel(
      optionLabel.option,
      optionLabel.label,
      translate
    ),
  }));
}
